// * 请求枚举配置
/**
 * @description：请求配置
 */
export enum ResultEnum {
  SUCCESS = 1,
  ERROR = 500,
  OVERDUE = 1003, //登录态过期，弹出
  REFRESH = 1004, //token刷新，无痕处理
  NO_PERMISSION = 1005, //没有接口权限
  CORP_DISABLED = 1011, //企业被禁用，弹出
  USER_DISABLED = 1012, //用户被禁用，弹出
  PLATFORM_DISABLED = 1013, //企业的平台被禁用，弹出
  USER_LEFT = 1014, //成员离职，弹出
  TIMEOUT = 20000, //超时时间
  SERVER_UPDATING = 999, //服务器升级中
  TYPE = 'success'
}

/**
 * @description：请求方法
 */
export enum RequestEnum {
  GET = 'GET',
  POST = 'POST',
  PATCH = 'PATCH',
  PUT = 'PUT',
  DELETE = 'DELETE'
}

/**
 * @description：常用的contentTyp类型
 */
export enum ContentTypeEnum {
  // json
  JSON = 'application/json;charset=UTF-8',
  // text
  TEXT = 'text/plain;charset=UTF-8',
  // form-data 一般配合qs
  FORM_URLENCODED = 'application/x-www-form-urlencoded;charset=UTF-8',
  // form-data 上传
  FORM_DATA = 'multipart/form-data;charset=UTF-8'
}

/**
 * 服务端返回码
 */
export const enum Code {
  SUCCESS = 1,
  LOST_LOGIN = 10001, // 登录失效
  VALIDATE_FAILED = 10002, // 验证错误
  NO_PERMISSION = 10003, //没有接口权限
  LOST_FAILED = 10004, // 登录失败
  ERROR = 10005, // 操作失败
  OVERDUE = 10006, //登录态过期，弹出
  LOGIN_BLACKLIST = 10007, //黑名单
  USER_DISABLED = 10008, //用户被禁用，弹出
  WECHAT_RESPONSE_ERROR = 40000
}

/**
 * status
 */
export const enum Status {
  ENABLE = 1,
  DISABLE = 2
}

/**
 * 白名单页面
 *
 * 不需要权限认证
 */
export const enum WhiteListPage {
  LOGIN_PATH = '/login',
  BI = '/bi',
  BIVIEW = '/biview',
  NOT_FOUND_PATH = '/404'
}
